<template>
  <swiper class="swiper" :options="swiperOption">
    <swiper-slide class="background" v-for="(item, index) in pictures" :key="index"
    :style="{ backgroundImage: 'url(' + item + ')'}" @click.native="openModal(index)">
      <div class="number_text">{{index+1}} / {{pictures.length}}</div>
    </swiper-slide>
    <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
    <div class="arrow swiper-button-prev swiper-button-white" slot="button-prev"></div>
    <div class="arrow swiper-button-next swiper-button-white" slot="button-next"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'swiper-example-loop',
  title: 'Loop mode / Infinite loop',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    pictures: {
      type: Array,
      default: () => ([
        'https://picsum.photos/600/300?random=1',
        'https://picsum.photos/600/300?random=2',
        'https://picsum.photos/600/300?random=3',
        'https://picsum.photos/600/300?random=4',
      ]),
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  methods: {
    openModal(index) {
      console.log('index小:', index);
      this.$bus.$emit('pictureModal:open', this.pictures, index);
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper {
  height: 360px;
  .swiper-slide {
    background: no-repeat center;
    background-size: contain;
    .number_text {
      color: rgb(185, 185, 185);
      background-color: rgb(245, 245, 245);
      // background-color: rgb(255, 255, 255);
      border-radius: 10px;
      padding: 3px 7px;
      position: absolute;
      top: 0;
    }
  }
  .swiper-pagination{
    background-color: rgba(190, 190, 190, 0.5);
    position: absolute;
    bottom: 0;
    .swiper-pagination-bullet{
      outline: none;
    }
  }
  .arrow{
    text-shadow: 1px 1px 5px #949494;
  }
}
</style>
